import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import { logActions } from "../../../../../store/log-slice"
import Pagination from "./pagination"


const Filter = (props) => {

    let defaultlogcount = useSelector((state) => state.log.filterlogCount)
    let pagination = useSelector((state) => state.log.pagination)

    let sliceFilters = useSelector(state => state.log.filter)
    let sliceActions = logActions
    let sliceItems = useSelector(state => state.log.logs)
    const [isMount, setIsMount] = useState(false)

    const { children } = props


    let dispatch = useDispatch()

    const { doFilter } = useFilter()
    const { variableValue } = useVariable()

    const [paginationItems, setPaginationItems] = useState([])

    useEffect(() => {
        let items = []
        if (pagination) {
            pagination.map((item, key) => {

                items.push(<Pagination key={key} logs={item} index={key} />)
            })
        }

        setPaginationItems(items)
    }, [pagination])



    useEffect(() => {

        if (!isMount) {
            setIsMount(true)
            return
        }

        doFilter(sliceFilters, sliceItems, sliceActions)


    }, [sliceFilters])


    return <div className="p-3" >
        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
            <div>
                <label>Pagination</label> <select name="filter-pagination" defaultValue={sliceFilters.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)

                    dispatch(logActions.setFilter({
                        key: 'pagination',
                        value
                    }))



                }} >
                    <option value='' >All</option>

                    {
                        defaultlogcount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <input type="text" name="filter-userid-method" className="mb-2" defaultValue={sliceFilters.search} placeholder="userid or method" onInput={(event) => {
                    let value = variableValue(event.target.value)


                    dispatch(logActions.setFilter({
                        key: 'search',
                        value
                    }))


                }} />
            </div>

        </div>

        {children}
        <div className="pagination-container">{paginationItems}</div>

    </div>
}


export default Filter